import { ProductVariation } from '@typings/product';

export const createProductVariation = (data: ProductVariation): ProductVariation => {
  const attributesMap = Object.fromEntries(
    data.variationValues.map(({ name, value }) => [name, value]),
  ) as ProductVariation['attributesMap'];

  const isOrderable = data.inventory.orderable && data.price > 0;
  const customFields = data.customFields ? JSON.parse(data.customFields) : {};
  const grillSize = customFields?.['c_grillArea (SI)'];
  return {
    ...data,
    sku: data.id,
    attributesMap,
    isOrderable,
    grillSize,
  };
};
